/**
 * MIT License
 *
 * Copyright (c) 2022 Brendan C. Ward, Astute Spruce, LLC
 * Source: github.com/astutespruce/sarp-connectivity
 * Changes copyright (c) 2022 University of Washington

 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:

 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

export const hasWindow = typeof window !== 'undefined' && window

export const isUnsupported =
  hasWindow &&
  navigator !== undefined &&
  (/MSIE 9/i.test(navigator.userAgent) ||
    /MSIE 10/i.test(navigator.userAgent) ||
    /Trident/i.test(navigator.userAgent))

export const isDebug = hasWindow && process.env.NODE_ENV === 'development'
export const isProduction = hasWindow && process.env.NODE_ENV === 'production'

export const hasGeolocation =
  hasWindow && navigator && 'geolocation' in navigator

/**
 * URI encode object key:value pairs
 *
 * @param {Object} data
 */
export const encodeParams = (obj) =>
  Object.keys(obj)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&')

export const saveToStorage = (key, data) => {
  if (!hasWindow) return

  window.localStorage.setItem(key, JSON.stringify(data))
}

export const getFromStorage = (key) =>
  JSON.parse(window.localStorage.getItem(key))

/**
 * Extract query params into a key / value object
 * @param {Object} location - location object from Gatsby or window.location
 * @returns Object
 */
export const getQueryParams = (location) => {
  if (!(location && hasWindow)) return []

  return Object.fromEntries([
    ...new window.URLSearchParams(location.search).entries(),
  ])
}
